module.exports = __webpack_public_path__ + "static/img/0003.0e53d0bf.png";